import script from "./OcrAmountDifferenceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrAmountDifferenceModal.vue?vue&type=script&setup=true&lang=ts"

import "./OcrAmountDifferenceModal.vue?vue&type=style&index=0&id=5ef1696b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef1696b"]])

export default __exports__